"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1708))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:45:00.110Z
 */
export const SynchronizedWarning = createSVGIcon(
  <>
    <path
      d="M18.8572 15.4286L22.2857 14.5714L23.1429 18"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.2858 14.5714C21.5569 16.7492 20.1824 18.6536 18.3452 20.0315C16.5079 21.4095 14.2949 22.1957 12.0001 22.2857V22.2857C9.89044 22.2796 7.83329 21.6274 6.10558 20.4167C4.37786 19.206 3.06254 17.4951 2.33667 15.5143"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.14289 8.57143L1.71432 9.42857L0.857178 6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.71436 9.42852C2.48006 7.27359 3.86429 5.39235 5.69383 4.0202C7.52336 2.64804 9.71694 1.84593 12.0001 1.71423V1.71423C14.1097 1.7203 16.1669 2.37257 17.8946 3.58323C19.6223 4.79388 20.9376 6.5048 21.6635 8.48566"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6V12.8571"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1428 17.1428C11.1428 17.3701 11.2331 17.5881 11.3939 17.7489C11.5546 17.9096 11.7726 17.9999 12 17.9999C12.2273 17.9999 12.4453 17.9096 12.6061 17.7489C12.7668 17.5881 12.8571 17.3701 12.8571 17.1428C12.8571 16.9155 12.7668 16.6974 12.6061 16.5367C12.4453 16.3759 12.2273 16.2856 12 16.2856C11.7726 16.2856 11.5546 16.3759 11.3939 16.5367C11.2331 16.6974 11.1428 16.9155 11.1428 17.1428Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "SynchronizedWarning",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
